























import { Component, Prop, Vue } from 'vue-property-decorator';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import ClearIcon from '@/components/icons/ClearIcon.vue';
import { UPDATED_STATUS_WARNING_VARIANTS, UpdatedStatusWarningVariant } from '@/common/transaction-utils';

@Component({ components: { InfoIcon, SuccessIcon, ClearIcon } })
export default class UpdatedStatusWarning extends Vue {
  @Prop(Boolean) readonly show!: boolean;
  @Prop(String) readonly message!: string;
  @Prop({ default: UPDATED_STATUS_WARNING_VARIANTS.WARNING }) readonly variant!: UpdatedStatusWarningVariant;

  get iconComponent () {
    switch (this.variant) {
      case UPDATED_STATUS_WARNING_VARIANTS.PROMINENT:
        return InfoIcon;
      case UPDATED_STATUS_WARNING_VARIANTS.WARNING:
        return InfoIcon;
      case UPDATED_STATUS_WARNING_VARIANTS.SUCCESSFUL:
        return SuccessIcon;
    }
  }
}
